export default __webpack_public_path__ + "static/Tek_Grenade_Launcher-e84a94e23516bf55dfee946ce6a2f777.png";